var _g, _g2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeBgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1182,
    viewBox: "0 0 1920 1182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2052_5398)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.31,
    filter: "url(#filter0_bi_2052_5398)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 320.066,
    cy: 676.97,
    rx: 320.066,
    ry: 676.97,
    transform: "matrix(-0.446835 0.894616 0.894616 0.446835 -31.2172 -203.235)",
    fill: "url(#paint0_linear_2052_5398)",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.623 663.433C458.893 746.48 624.93 789.576 758.716 792.463C893.31 795.368 991.631 757.709 1028.52 683.844C1065.42 609.979 1036.47 508.751 953.297 402.889C870.627 297.663 736.437 190.805 570.167 107.758C403.897 24.7106 237.86 -18.3856 104.074 -21.2731C-30.5198 -24.178 -128.842 13.481 -165.735 87.346C-202.629 161.211 -173.677 262.439 -90.5072 368.301C-7.83668 473.527 126.353 580.386 292.623 663.433Z",
    stroke: "url(#paint1_linear_2052_5398)",
    strokeOpacity: 0.2,
    strokeWidth: 19
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2052_5398)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 320.066,
    cy: 676.97,
    rx: 320.066,
    ry: 676.97,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 942.752 895.865)",
    fill: "url(#paint2_linear_2052_5398)",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1844.34 1103.52C2005.3 1010.59 2132.8 895.834 2208.97 785.812C2285.6 675.125 2308.39 572.334 2267.1 500.83C2225.82 429.325 2125.41 397.667 1991.23 408.688C1857.87 419.643 1694.73 472.679 1533.78 565.607C1372.82 658.535 1245.32 773.295 1169.15 883.318C1092.52 994.005 1069.73 1096.8 1111.01 1168.3C1152.3 1239.8 1252.71 1271.46 1386.88 1260.44C1520.25 1249.49 1683.39 1196.45 1844.34 1103.52Z",
    stroke: "url(#paint3_linear_2052_5398)",
    strokeWidth: 19
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_2052_5398",
    x: -240.027,
    y: -79.9239,
    width: 1342.84,
    height: 931.038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24.4976
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2052_5398"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2052_5398",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 60,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_2052_5398"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 35.9965
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.7956
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.603922 0 0 0 0 0.301961 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2052_5398"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2052_5398",
    x: 1081.18,
    y: 397.054,
    width: 1251.75,
    height: 875.021,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 60,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2052_5398"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 35.9965
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.7956
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.603922 0 0 0 0 0.301961 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2052_5398"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2052_5398",
    x1: 432.619,
    y1: 32.2705,
    x2: -315.691,
    y2: 840.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2052_5398",
    x1: 186.252,
    y1: 885.265,
    x2: 399.047,
    y2: 399.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D3900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2052_5398",
    x1: 432.619,
    y1: 32.2705,
    x2: -315.691,
    y2: 840.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2052_5398",
    x1: 1970.76,
    y1: 1314.57,
    x2: 1682.49,
    y2: 868.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D3900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2052_5398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1182,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeBgEllipse);
export default __webpack_public_path__ + "static/media/orange_bg_ellipse.8143cbbfeb3b0b7a7979f950a89e50dd.svg";
export { ForwardRef as ReactComponent };